import {
  Box,
  Link
} from "@mui/material";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import { styled } from "@mui/material/styles";
import React from "react";
import CarForm from "../../../../Components/Common/CarForm/CarForm";
import HealthForm from "../../../../Components/Common/HealthForm/HealthForm";
import InvestmentForm from "../../../../Components/Common/InvestmentForm/InvestmentForm";
import TWForm from "../../../../Components/Common/TWForm/TWForm";
import TermForm from "../../../../Components/Common/TermForm/TermForm";
import TravelForm from "../../../../Components/Common/TravelForm/TravelForm";
import RiskScore from "../../../../Components/RiskScore/RiskScore";
import "./Dashboard.scss";

interface Props {
  value_update: Function;
}

const Dashboard: React.FC<Props> = ({ value_update }) => {
  const BorderLinearProgress = styled(LinearProgress)(() => ({
    height: 4,
    borderRadius: 4,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: "#DCFFDD",
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 4,
      backgroundColor: "#27AE60",
    },
  }));

  const [healthPopupStatus, setHealthPopupStatus] = React.useState(false);
  const [carPopupStatus, setCarPopupStatus] = React.useState(false);
  const [bikePopupStatus, setBikePopupStatus] = React.useState(false);
  const [termPopupStatus, setTermPopupStatus] = React.useState(false);
  const [investmentPopupStatus, setInvestmentPopupStatus] =
    React.useState(false);
  const [travelPopupStatus, setTravelPopupStatus] = React.useState(false);

  const updateMasterState = (attrName: string, value: boolean) => {
    if (attrName == "healthPopupStatus") {
      setHealthPopupStatus(value);
    } else if (attrName == "carPopupStatus") {
      setCarPopupStatus(value);
    } else if (attrName == "bikePopupStatus") {
      setBikePopupStatus(value);
    } else if (attrName == "termPopupStatus") {
      setTermPopupStatus(value);
    } else if (attrName == "investmentPopupStatus") {
      setInvestmentPopupStatus(value);
    } else if (attrName == "travelPopupStatus") {
      setTravelPopupStatus(value);
    }
  };

  return (
    <Grid container spacing={3}>
      {/* <-----------------------Health Form Pop-up Start---------------------------> */}
      <HealthForm
        attrName="healthPopupStatus"
        open_status={healthPopupStatus}
        value_update={updateMasterState}
      />
      {/* <-----------------------Health Form Pop-up End---------------------------> */}
      {/* <-----------------------Car Form Pop-up Start---------------------------> */}
      <CarForm
        attrName="carPopupStatus"
        open_status={carPopupStatus}
        value_update={updateMasterState}
      />

      {/* <-----------------------Car Form Pop-up End---------------------------> */}
      {/* <-----------------------TW Form Pop-up Start---------------------------> */}
      <TWForm
        attrName="bikePopupStatus"
        open_status={bikePopupStatus}
        value_update={updateMasterState}
      />
      {/* <-----------------------TW Form Pop-up End---------------------------> */}
      {/* <-----------------------Term Form Pop-up Start---------------------------> */}
      <TermForm
        attrName={"termPopupStatus"}
        open_status={termPopupStatus}
        value_update={updateMasterState}
      />
      {/* <-----------------------Term Form Pop-up End---------------------------> */}
      {/* <-----------------------Invest Form Pop-up Start---------------------------> */}
      <InvestmentForm
        attrName="investmentPopupStatus"
        open_status={investmentPopupStatus}
        value_update={updateMasterState}
      />
      {/* <-----------------------Invest Form Pop-up End---------------------------> */}
      {/* <-----------------------Travel Form Pop-up Start---------------------------> */}
      <TravelForm
        attrName="travelPopupStatus"
        open_status={travelPopupStatus}
        value_update={updateMasterState}
      />

      {/* <-----------------------Travel Form Pop-up End---------------------------> */}
      <Grid xs={8}>
        <h3>Dashboard</h3>
        <Box className="briefDetails">
          <Grid container alignItems="center" spacing={3}>
            <Grid xs={12} md={4}>
              <Box className="colSection">
                <img src="images/health_Insurance_Icon.svg" alt="img" />
                <span>
                  <p>Health Insurance</p>
                  <h4 className="inrIcon">5 Lakh</h4>
                  <p className="members">2 Adutls &amp; 1 Child</p>
                </span>
              </Box>
            </Grid>
            <Grid xs={12} md={4}>
              <Box className="colSection">
                <img src="images/life_insurance_icon.svg" alt="img" />
                <span>
                  <p>Life Insurance</p>
                  <h4 className="inrIcon">1 Crore</h4>
                </span>
              </Box>
            </Grid>
            <Grid xs={12} md={4}>
              <Box className="colSection">
                <img src="images/other_insurance.svg" alt="img" />
                <span>
                  <p>Other Insurance</p>
                  <h4>NA</h4>
                </span>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box className="highlightedTabs">
          <Grid container>
            <Grid sm={12} lg={6} sx={{ paddingLeft: "0px" }}>
              <Box
                className="articleSection"
                onClick={() => {
                  value_update("activePage", "community");
                }}
              >
                <span>
                  <h6>Articles</h6>
                  <p>
                    Read our blog to learn about nuances of your insurance
                    policies.
                  </p>
                </span>
              </Box>
            </Grid>
            <Grid sm={12} lg={6} sx={{ paddingRight: "0px" }}>
              <Box
                className="trendingdiscussion"
                onClick={() => {
                  value_update("activePage", "trendingquestions");
                }}
              >
                <span>
                  <h6>Trending Discussions</h6>
                  <p>
                    Connect, share and explore. Give feedback, discuss and find
                    answers.
                  </p>
                </span>
              </Box>
            </Grid>
            <Grid sm={12} lg={6} sx={{ paddingLeft: "0px" }}>
              <Box
                className="initiateclaim"
                onClick={() => {
                  value_update("activePage", "claimassistant");
                }}
              >
                <span>
                  <h6>Initiate Claim</h6>
                  <p>
                    Use your policies effectively by initiating claims using EB.
                  </p>
                </span>
              </Box>
            </Grid>
            <Grid sm={12} lg={6} sx={{ paddingRight: "0px" }}>
              <Box
                className="riskmap"
                onClick={() => {
                  value_update("activePage", "riskmap");
                }}
              >
                <span>
                  <h6>Risk Map</h6>
                  <p>
                    Find your Riskscore and how your policies compare against
                    your ideal requirements.
                  </p>
                </span>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box className="buyInsurance">
          <h3>Buy Insurance</h3>
          <Grid container spacing={3}>
            <Grid md={3} lg={2}>
              <button
                className="healthInsurance"
                onClick={() => {
                  setHealthPopupStatus(true);
                }}
              >
                Health
              </button>
            </Grid>
            <Grid md={3} lg={2}>
              <button
                className="carInsurance"
                onClick={() => {
                  setCarPopupStatus(true);
                }}
              >
                Car
              </button>
            </Grid>
            <Grid md={3} lg={2}>
              <button
                className="bikeInsurance"
                onClick={() => {
                  setBikePopupStatus(true);
                }}
              >
                Bike
              </button>
            </Grid>
            <Grid md={3} lg={2}>
              <button
                className="termInsurance"
                onClick={() => {
                  setTermPopupStatus(true);
                }}
              >
                Term
              </button>
            </Grid>
            <Grid md={3} lg={2}>
              <button
                className="investmentPlan"
                onClick={() => {
                  setInvestmentPopupStatus(true);
                }}
              >
                Investment
              </button>
            </Grid>
            <Grid md={3} lg={2}>
              <button
                className="travelInsurance"
                onClick={() => {
                  setTravelPopupStatus(true);
                }}
              >
                Travel
              </button>
            </Grid>
          </Grid>
        </Box>
      </Grid>
      <Grid xs={4}>
        <Box className="riskmapScore">
          <RiskScore class_name="svg-pi-wrapper" progress_one={50} />
        </Box>
        <Box className="todolist">
          <h4>To Do</h4>
          <Grid>
            <Link
              underline="none"
              className="addpolicy"
              onClick={() => {
                value_update("activePage", "policywallet");
              }}
            >
              Add Policies to the wallet.
            </Link>
          </Grid>
          <Grid>
            <Link
              underline="none"
              className="familyprofile"
              onClick={() => {
                value_update("activePage", "userprofile");
              }}
            >
              Complete family profile to share policies.
            </Link>
          </Grid>
          <Grid>
            <Link
              underline="none"
              className="riskscore"
              onClick={() => {
                value_update("activePage", "riskmap");
              }}
            >
              Find how to improve your Risk Score.
            </Link>
          </Grid>
          <Grid>
            <Link
              underline="none"
              className="addcity"
              onClick={() => {
                value_update("activePage", "userprofile");
              }}
            >
              Add city in the profile.
            </Link>
          </Grid>
        </Box>
        <Box>
          <h4>Requests</h4>
          <Box className="RequestBar">
            <p>
              Health Insurance <span className="green">Endorsement</span>
            </p>
            <h6>Member add, DOB &amp; Address</h6>
            <BorderLinearProgress variant="determinate" value={80} />
          </Box>
          <Box className="RequestBar">
            <p>
              Life Insurance <span className="red">Claim</span>
            </p>
            <BorderLinearProgress variant="determinate" value={20} />
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Dashboard;
